<template>
  <generic :modeParams="modeParams" @tryItNowDialogOpen="$emit('tryItNowDialogOpen')" ></generic>
</template>

<script>
  import generic from './home/generic'

  //import Vue from 'vue'
  import i18n from '@/i18n';
  import Page from '../mixins/page'

  export default {
    name: 'Home',
    mixins: [Page],
    computed: {
      pageTitle(){
        return i18n.t('home.pageTitle');
      },
      pageDescription(){
        return i18n.t('home.pageDescription', {platformName: 'Stadia, xCloud and GeforceNow'});
      }
    },
    components: {generic},
    data: () => ({
      modeParams: {
        mode: 'generic',
        platformName: 'Cloud Gaming',
        platformNameVariant2: 'Cloud Gaming services',
        supportedPlatforms: {
          stadia: [
            {title: 'Mac OS', soon: false},
            {title: 'Windows', soon: false},
            {title: 'Linux', soon: false},
            {title: 'Android', soon: false},
            {title: 'IOS', soon: false},
            {title: 'ChromeCast', soon: false}
          ],
          xcloud: [
            {title: 'Android', soon: false},
            {title: 'XBox', soon: false},
            {title: 'PC <small>(Browser)</small>', soon: false},
            {title: 'IOS', soon: false},
            {title: 'PC <small>(App)</small>', soon: true},
          ]
        }
      }
    })
  };

</script>
